import * as React from "react";
import { forwardRef } from "react";
const SvgShortRightArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 8, viewBox: "0 0 12 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.78032 4.66667L6.39366 7.06L7.33366 8L11.3337 4L7.33366 0L6.39366 0.94L8.78032 3.33333H0.666992V4.66667H8.78032Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgShortRightArrow);
export { ForwardRef as ReactComponent };
